// web/src/components/KPICard.tsx — surface card; Fira Code value (D05).
import { TONE_TEXT } from '../lib/status';

export function KPICard({ label, value, accent, delta }: {
  label: string; value: string | number; accent?: 'run' | 'info' | 'warn' | 'danger'; delta?: string;
}) {
  return (
    <div className="rounded-lg border border-hair bg-surface p-4">
      <div className="text-[13px] text-muted">{label}</div>
      <div className="mt-1 flex items-baseline gap-2">
        <span className={`font-head text-2xl font-medium ${accent ? TONE_TEXT[accent] : 'text-ink'}`}>{value}</span>
        {delta && <span className="font-head text-xs text-run">{delta}</span>}
      </div>
    </div>
  );
}
